import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { RapidFilesZohoComponent } from './rapid-files-zoho/rapid-files-zoho.component';
import { RapidFilesPortalComponent } from './rapid-files-portal/rapid-files-portal.component';

@Component({
	selector: 'app-rapid-files',
	templateUrl: './rapid-files.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./rapid-files.component.scss'],
	imports: [
		MatTabGroup,
		MatTab,
		RapidFilesZohoComponent,
		RapidFilesPortalComponent,
	],
})
export class RapidFilesComponent {}
